export default "__VITE_ASSET__f1142711__"